import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {CheckBox} from "devextreme-react/check-box";
import {NumberBox} from "devextreme-react/number-box";
import Validator from "devextreme-react/validator";
import {RequiredRule} from "devextreme-react/form";
import {Cutout} from "../../types/Cutout";
import {SelectedCutout} from "../../types/SelectedCutout";
import {CUTOUT_FALLBACK_IMAGE, getCutoutImageUrl} from "../../utils/cutoutImage";

export function CutoutControl({prodQteGrpID, cutout, selectedCutout, laborQty}: {
    prodQteGrpID: number,
    cutout: Cutout,
    selectedCutout: SelectedCutout | undefined,
    laborQty: number
}) {
    const context = useCountertops();
    const [checked, setChecked] = useState<boolean>(false);

    useEffect(() => {
        if (selectedCutout === undefined) {
            if (laborQty > 0) {
                setChecked(true);
            } else {
                setChecked(false);
            }
        } else {
            setChecked(true);
        }
    }, [selectedCutout, laborQty])

    return (<tr key={cutout.productID}>
            <td style={{width: '30px', textAlign: "center"}}>
                <CheckBox
                    value={checked}
                    readOnly={laborQty > 0}
                    onValueChanged={(e) => {
                        if (e.event) {
                            if (e.value) {
                                context.updateCutout(prodQteGrpID, cutout.productID, undefined);
                            } else {
                                context.removeCutout(prodQteGrpID, cutout.productID);
                            }
                        }
                    }}
                />
            </td>
            <td>
                {cutout.sku}&nbsp;
            </td>
            <td>
                {cutout.name}
            </td>
            <td>
                <img
                    src={getCutoutImageUrl(cutout.imageUrl)}
                    alt={cutout.name}
                    style={{maxWidth: '30px'}}
                    onError={({currentTarget}) => {
                        currentTarget.onerror = null;
                        currentTarget.src = CUTOUT_FALLBACK_IMAGE;
                    }}
                />
            </td>
            <td style={{width: '62px'}}>
                <NumberBox
                    min={Math.max(1, laborQty)}
                    style={{width: '60px'}}
                    showSpinButtons={true}
                    value={laborQty === 0 ? selectedCutout?.qty : ((selectedCutout?.qty ?? 0) + laborQty)}
                    disabled={!checked}
                    valueChangeEvent='blur'
                    format={'fixedPoint'}
                    onValueChanged={(e) => {
                        if (e.event) {
                            let qty = e.value ?? undefined;
                            if (laborQty > 0) {
                                qty = (qty ?? 0) - laborQty;
                            }
                            context.updateCutout(prodQteGrpID, cutout.productID, qty);
                        }
                    }}
                >
                    <Validator>
                        <RequiredRule message={"Quantity must be set and greater than 0"}></RequiredRule>
                    </Validator>
                </NumberBox>
            </td>
            <td style={{width: '42px'}}>
                {cutout.uom}
            </td>
        </tr>
    )
}
